// extracted by mini-css-extract-plugin
module.exports = {"dummy":"DummyProductPreview_dummy__QrZsR","image":"DummyProductPreview_image__3YyTm","link":"DummyProductPreview_link__2OmAP","content":"DummyProductPreview_content__1h3kG"};